/**
 * Binance C2C REST API
 *
 * OpenAPI Specification for the Binance C2C REST API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    ConfigurationRestAPI,
    TimeUnit,
    RestApiResponse,
    sendRequest,
    type RequestArgs,
} from '@binance/common';
import type { GetC2CTradeHistoryResponse } from '../types';

/**
 * C2CApi - axios parameter creator
 */
const C2CApiAxiosParamCreator = function (configuration: ConfigurationRestAPI) {
    return {
        /**
         * Get C2C Trade History
         *
         * The max interval between startTime and endTime is 30 days.
         * If startTime and endTime are not sent, the recent 7 days' data will be returned.
         * The earliest startTime is supported on June 10, 2020
         * Return up to 200 records per request.
         *
         * Weight: 1
         *
         * @summary Get C2C Trade History (USER_DATA)
         * @param {number} [startTime]
         * @param {number} [endTime]
         * @param {number} [page] Default 1
         * @param {number} [recvWindow]
         *
         * @throws {RequiredError}
         */
        getC2CTradeHistory: async (
            startTime?: number,
            endTime?: number,
            page?: number,
            recvWindow?: number
        ): Promise<RequestArgs> => {
            const localVarQueryParameter: Record<string, unknown> = {};

            if (startTime !== undefined && startTime !== null) {
                localVarQueryParameter['startTime'] = startTime;
            }

            if (endTime !== undefined && endTime !== null) {
                localVarQueryParameter['endTime'] = endTime;
            }

            if (page !== undefined && page !== null) {
                localVarQueryParameter['page'] = page;
            }

            if (recvWindow !== undefined && recvWindow !== null) {
                localVarQueryParameter['recvWindow'] = recvWindow;
            }

            let _timeUnit: TimeUnit | undefined;
            if ('timeUnit' in configuration) _timeUnit = configuration.timeUnit as TimeUnit;

            return {
                endpoint: '/sapi/v1/c2c/orderMatch/listUserOrderHistory',
                method: 'GET',
                params: localVarQueryParameter,
                timeUnit: _timeUnit,
            };
        },
    };
};

/**
 * C2CApi - interface
 * @interface C2CApi
 */
export interface C2CApiInterface {
    /**
     * Get C2C Trade History
     *
     * The max interval between startTime and endTime is 30 days.
     * If startTime and endTime are not sent, the recent 7 days' data will be returned.
     * The earliest startTime is supported on June 10, 2020
     * Return up to 200 records per request.
     *
     * Weight: 1
     *
     * @summary Get C2C Trade History (USER_DATA)
     * @param {GetC2CTradeHistoryRequest} requestParameters Request parameters.
     *
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof C2CApiInterface
     */
    getC2CTradeHistory(
        requestParameters?: GetC2CTradeHistoryRequest
    ): Promise<RestApiResponse<GetC2CTradeHistoryResponse>>;
}

/**
 * Request parameters for getC2CTradeHistory operation in C2CApi.
 * @interface GetC2CTradeHistoryRequest
 */
export interface GetC2CTradeHistoryRequest {
    /**
     *
     * @type {number}
     * @memberof C2CApiGetC2CTradeHistory
     */
    readonly startTime?: number;

    /**
     *
     * @type {number}
     * @memberof C2CApiGetC2CTradeHistory
     */
    readonly endTime?: number;

    /**
     * Default 1
     * @type {number}
     * @memberof C2CApiGetC2CTradeHistory
     */
    readonly page?: number;

    /**
     *
     * @type {number}
     * @memberof C2CApiGetC2CTradeHistory
     */
    readonly recvWindow?: number;
}

/**
 * C2CApi - object-oriented interface
 * @class C2CApi
 */
export class C2CApi implements C2CApiInterface {
    private readonly configuration: ConfigurationRestAPI;
    private localVarAxiosParamCreator;

    constructor(configuration: ConfigurationRestAPI) {
        this.configuration = configuration;
        this.localVarAxiosParamCreator = C2CApiAxiosParamCreator(configuration);
    }

    /**
     * Get C2C Trade History
     *
     * The max interval between startTime and endTime is 30 days.
     * If startTime and endTime are not sent, the recent 7 days' data will be returned.
     * The earliest startTime is supported on June 10, 2020
     * Return up to 200 records per request.
     *
     * Weight: 1
     *
     * @summary Get C2C Trade History (USER_DATA)
     * @param {GetC2CTradeHistoryRequest} requestParameters Request parameters.
     * @returns {Promise<RestApiResponse<GetC2CTradeHistoryResponse>>}
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof C2CApi
     * @see {@link https://developers.binance.com/docs/c2c/rest-api/Get-C2C-Trade-History Binance API Documentation}
     */
    public async getC2CTradeHistory(
        requestParameters: GetC2CTradeHistoryRequest = {}
    ): Promise<RestApiResponse<GetC2CTradeHistoryResponse>> {
        const localVarAxiosArgs = await this.localVarAxiosParamCreator.getC2CTradeHistory(
            requestParameters?.startTime,
            requestParameters?.endTime,
            requestParameters?.page,
            requestParameters?.recvWindow
        );
        return sendRequest<GetC2CTradeHistoryResponse>(
            this.configuration,
            localVarAxiosArgs.endpoint,
            localVarAxiosArgs.method,
            localVarAxiosArgs.params,
            localVarAxiosArgs?.timeUnit,
            { isSigned: true }
        );
    }
}
